import ResponseBodyStreaming_vue_vue_type_script_setup_true_lang_default from "./ResponseBodyStreaming.vue.script.js";
//#region src/v2/blocks/response-block/components/ResponseBodyStreaming.vue
var ResponseBodyStreaming_default = ResponseBodyStreaming_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ResponseBodyStreaming_default as default };

//# sourceMappingURL=ResponseBodyStreaming.vue.js.map